import React from 'react';
import { Pipette } from 'lucide-react';

const HEX = /^#[0-9a-fA-F]{6}$/;
const FIELDS = [
  { key: 'secondary_color', label: 'Fundo (cabeçalho)' },
  { key: 'primary_color', label: 'Principal (botões)' },
  { key: 'accent_color', label: 'Destaque' }
];

export const ColorField = ({ label, value, onChange, testId }) => {
  const [text, setText] = React.useState(value);
  React.useEffect(() => setText(value), [value]);
  const pick = async () => {
    try {
      const result = await new window.EyeDropper().open();
      onChange(result.sRGBHex.length === 7 ? result.sRGBHex : value);
    } catch (e) {
      // user cancelled
    }
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
      <span style={{ fontSize: '0.75rem', color: '#4a5568', fontWeight: 500 }}>{label}</span>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
        <input type="color" value={value} onChange={(e) => onChange(e.target.value)} data-testid={`${testId}-picker`}
          style={{ width: '42px', height: '36px', padding: 0, border: '1px solid #e2e8f0', borderRadius: '6px', cursor: 'pointer', background: 'white' }} />
        <input type="text" value={text} maxLength={7} data-testid={`${testId}-hex`}
          onChange={(e) => { const v = e.target.value.startsWith('#') ? e.target.value : `#${e.target.value}`; setText(v); if (HEX.test(v)) onChange(v.toUpperCase()); }}
          style={{ width: '84px', height: '36px', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '0 0.5rem', fontFamily: 'monospace', fontSize: '0.85rem', textTransform: 'uppercase' }} />
        {typeof window !== 'undefined' && 'EyeDropper' in window && (
          <button type="button" onClick={pick} title="Conta-gotas: capturar cor da tela" data-testid={`${testId}-eyedropper`}
            style={{ width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e2e8f0', borderRadius: '6px', background: 'white', cursor: 'pointer' }}>
            <Pipette className="w-4 h-4" style={{ color: '#4a5568' }} />
          </button>
        )}
      </div>
    </div>
  );
};

export const CustomPaletteEditor = ({ theme, onChange }) => {
  const selected = theme.palette_id === 'custom';
  const update = (key, color) => onChange({ ...theme, [key]: color, text_color: theme.text_color || '#2D3748', palette_id: 'custom' });
  return (
    <div data-testid="custom-palette-editor" onClick={() => !selected && onChange({ ...theme, palette_id: 'custom' })}
      style={{ marginTop: '1rem', padding: '1rem', borderRadius: '10px', border: selected ? `2px solid ${theme.primary_color}` : '1px dashed #cbd5e0', background: selected ? '#f7fafc' : 'white', cursor: selected ? 'default' : 'pointer', transition: 'border-color 0.2s ease, background-color 0.2s ease' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
        <div>
          <p style={{ fontWeight: 600, color: '#2D3748', fontSize: '0.9rem' }}>Paleta personalizada</p>
          <p style={{ fontSize: '0.75rem', color: '#718096' }}>Escolha livremente as 3 cores do tema, no espectro ou com o conta-gotas.</p>
        </div>
        <div style={{ display: 'flex', gap: '3px' }}>
          {FIELDS.map((f) => <div key={f.key} style={{ width: '24px', height: '24px', background: theme[f.key], borderRadius: '4px' }} />)}
        </div>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.25rem' }}>
        {FIELDS.map((f) => (
          <ColorField key={f.key} label={f.label} value={theme[f.key]} onChange={(c) => update(f.key, c)} testId={`custom-${f.key.replace('_color', '')}`} />
        ))}
      </div>
    </div>
  );
};

const BG_PRESETS = ['#F7FAFC', '#FFFFFF', '#FDF6EC', '#EEF2F7', '#F0FFF4', '#1A202C'];

export const PageBackgroundPicker = ({ theme, onChange }) => {
  const value = theme.page_bg_color || '#F7FAFC';
  const set = (c) => onChange({ ...theme, page_bg_color: c });
  return (
    <div data-testid="page-bg-picker" style={{ marginTop: '1.5rem', padding: '1rem', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
      <p style={{ fontWeight: 600, color: '#2D3748', fontSize: '0.9rem' }}>Cor do fundo da página</p>
      <p style={{ fontSize: '0.75rem', color: '#718096', marginBottom: '0.75rem' }}>Área central do catálogo, onde ficam os livros, a busca e os botões de exibição.</p>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: '1.25rem', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', gap: '0.4rem' }}>
          {BG_PRESETS.map((c) => (
            <button key={c} type="button" onClick={() => set(c)} title={c} data-testid={`page-bg-preset-${c.slice(1)}`}
              style={{ width: 32, height: 32, borderRadius: 6, background: c, cursor: 'pointer', border: value.toUpperCase() === c ? '2px solid #3182ce' : '1px solid #cbd5e0' }} />
          ))}
        </div>
        <ColorField label="Cor livre" value={value} onChange={set} testId="page-bg" />
      </div>
    </div>
  );
};
